import { Injectable } from '@angular/core';
import { HttpClientService } from '@fitscovery/partner-web/shared/services/http';
import { environment } from 'apps/partner-web/src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { XendItInvoiceResponse, XendItInvoiceRequest } from '../models';
import { Select } from '@ngxs/store';
import { AuthState } from '@fitscovery/auth/data-access';

@Injectable()
export class ApiXendItService {

    @Select(AuthState.token) userToken$: Observable<string>;
    token: string;

    constructor(
        private httpClient: HttpClientService,
    ) {
        this.userToken$.subscribe(async (token: string) => {
            this.token = token;
        });
    }

    async createInvoice(xendItRequest: XendItInvoiceRequest): Promise<XendItInvoiceResponse> {
        return this.httpClient.post(`${environment.xendItApi.url}/invoices`, xendItRequest, this.token)
            .pipe(
                map((result: any) => {
                    return result.data;
                }),
                catchError((error: any) => {
                    return throwError(error);
                })
            ).toPromise();
    }
}
